module.exports = __webpack_public_path__ + "static/media/196.80e4d2c0.webp";